<app-diagnostic-topbar (dateRangeSelected)="setDate($event)" (metricSelected)="setMetric($event)"
                       [totalResults]="results" [type]="type"></app-diagnostic-topbar>
<div class="fixed-height" id="user-chart">
  <div id="fitness-chart"></div>
</div>
